import { GraphNode } from "./graph-node.model";

export class TreeNode extends GraphNode {

	public hasChildren: boolean;

	public iconCss: string;

}
